import ApiMsEntregasService from '@/services/ms_entregas_service'

export const state = {
  pendingBundles: [],
  loadingPendingBundles: false,
}

export const getters = {
  pendingBundles: (state) => state.pendingBundles,
  loadingPendingBundles: (state) => state.loadingPendingBundles,
}

export const mutations = {
  SET_PENDING_BUNDLES(state, payload) {
    state.pendingBundles = payload
  },
  SET_LOADING_PENDING_BUNDLES(state, payload) {
    state.loadingPendingBundles = payload
  },
}

export const actions = {
  async getPendingBundles({ commit }) {
    commit('SET_LOADING_PENDING_BUNDLES', true)
    try {
      const resp = (await ApiMsEntregasService.get('/api/promotion/pending_bundles')).data
      commit('SET_PENDING_BUNDLES', resp)
      return resp
    } catch (error) {
      return error.response
    } finally {
      commit('SET_LOADING_PENDING_BUNDLES', false)
    }
  },
  async runPromotionEngine({ commit }) {
    // post()/put() already swallow their own errors and resolve with the raw axios error
    // object instead of rejecting (matches ApiMsMaterialsService's convention elsewhere in
    // this codebase) - callers check resp.status before touching resp.data.
    commit('SET_LOADING_PENDING_BUNDLES', true)
    const resp = await ApiMsEntregasService.post('/api/promotion/run_promotion_engine')
    if (resp && resp.status === 200) {
      commit('SET_PENDING_BUNDLES', resp.data)
    }
    commit('SET_LOADING_PENDING_BUNDLES', false)
    return resp
  },
  async getBundleStatus({ commit }, payload) {
    try {
      return (
        await ApiMsEntregasService.get(`/api/promotion/bundle_status/${payload.bundle_id}`)
      ).data
    } catch (error) {
      return null
    }
  },
  async getBundleInvoices({ commit }, payload) {
    try {
      return (
        await ApiMsEntregasService.get(`/api/promotion/bundle_invoices/${payload.bundle_id}`)
      ).data
    } catch (error) {
      return null
    }
  },
  async forcePromoteBundle({ commit }, payload) {
    return await ApiMsEntregasService.put('/api/promotion/force_promote_bundle', payload)
  },
  async setBundleUrgent({ commit }, payload) {
    const resp = await ApiMsEntregasService.put('/api/promotion/set_bundle_urgent', payload)
    if (resp && resp.status === 200) {
      commit('SET_PENDING_BUNDLES', resp.data)
    }
    return resp
  },
}
